import { c as _c } from "react/compiler-runtime";
export const DeleteConfirmationLoader = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col items-center gap-3 "><div className="bg-skeleton-primary h-3 w-full animate-pulse rounded-lg text-transparent">.</div><div className="bg-skeleton-primary h-3 w-full animate-pulse rounded-lg text-transparent">.</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};